import { render } from "./ExportPhysician.vue?vue&type=template&id=35dee440"
import script from "./ExportPhysician.vue?vue&type=script&lang=js"
export * from "./ExportPhysician.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/physicians/ExportPhysician.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35dee440"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35dee440', __exports__)) {
    console.log('reload')
    api.reload('35dee440', __exports__)
  }
  
  module.hot.accept("./ExportPhysician.vue?vue&type=template&id=35dee440", () => {
    console.log('re-render')
    api.rerender('35dee440', render)
  })

}


export default __exports__